const modalTriggerClasses = {
  buttonHidden: 'faceted-search-modal-triggers__trigger--hidden',
  dropdownContainerHidden:
    'faceted-search-modal-triggers__dropdown-container--hidden',
  dropdownVisible: 'faceted-search-modal-triggers__dropdown--visible',
  countHidden: 'faceted-search-filter-count--hide',
};

const modalTriggerSelectors = {
  desktopContainer: '[data-modal-triggers-desktop-container]',
  dropdownContainer: '[data-modal-triggers-dropdown-container]',
  dropdownTrigger: '[data-modal-triggers-dropdown-trigger]',
  dropdown: '[data-modal-triggers-dropdown]',
  dropdownTriggers: '[data-comp-modal-trigger]',
  dropdownCount: '[data-dropdown-count]',
  dropdownOverlay: '[data-modal-triggers-overlay]',
  filterCount: 'faceted-search-filter-count',
  triggerContainer: '[data-modal-triggers-container]',
  triggers: '[data-comp-modal-trigger]',
  visibleButtons: `button:not(.${modalTriggerClasses.buttonHidden})`,
};

export { modalTriggerClasses, modalTriggerSelectors };
